import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {IAppState} from "../../../../shared/redux-store/store";
import {Apollo} from "apollo-angular";
import {NgRedux} from "@angular-redux/store";
import {SessionActions} from "../../../../shared/actions/session.actions";
import {MaintenanceData, MaintenanceService} from "../../maintenance/maintenance.service";
import {Subscription} from "rxjs/Subscription";
import {Observable} from "rxjs/Observable";

@Component({
  selector: 'vb-maintenance-view',
  templateUrl: './maintenance-view.component.html',
  styleUrls: ['./maintenance-view.component.css']
})
export class MaintenanceViewComponent implements OnInit, OnDestroy {

  private maintenanceStatusQuery$: Observable<MaintenanceData>;

  public maintenanceData: MaintenanceData;
  private sub: Subscription;

  constructor(private router: Router,
              private ngRedux: NgRedux<IAppState>,
              private sessionActions: SessionActions,
              private apollo: Apollo,
              private maintenanceService: MaintenanceService) {

    try {
      const queryManager = this.apollo && this.apollo.getClient() ? this.apollo.getClient().queryManager : null;

      for (let id in queryManager.queryStore.getStore()) {
        queryManager.stopQuery(id);
        queryManager.stopQueryInStore(id);
        queryManager.removeObservableQuery(id);
        queryManager.removeQuery(id);
      }

    } catch (err) {
      console.warn("Error during stopping queries", [err]);
    }

  }

  ngOnInit() {

    this.maintenanceStatusQuery$ = this.maintenanceService.getMaintenanceStatus();
    this.sub = this.maintenanceStatusQuery$.subscribe(res => {
      this.maintenanceData = res;
      if (this.maintenanceData && this.maintenanceData.maintenance === false) {
        this.router.navigate(['/']);
      }
    });

  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/views/maintenance-view/maintenance-view.component.ts